export default __webpack_public_path__ + "static/media/(1).59fcd8ce.jpeg";